import { Component, OnInit } from '@angular/core';
import { DragAndDropBaseComponent } from '../drag-and-drop-base-component/drag-and-drop-base.component';
import { UserService } from './../../../../shared/services/user/user.service';
import { TranslatorService } from './../../../../shared/services/utils/translator.service';

@Component({
  selector: 'ngx-users-drag-and-drop',
  templateUrl: './../drag-and-drop-base-component/drag-and-drop-base.component.html',
  styleUrls: ['./../drag-and-drop-base-component/drag-and-drop-base.component.scss']
})
export class UsersDragAndDropComponent extends DragAndDropBaseComponent implements OnInit {

  usersList = [];

  constructor(private readonly userService: UserService, translatorService: TranslatorService) {
    super(translatorService);
  }

  ngOnInit() {
    this.userService.usersQuery$(null, null).subscribe(res => {
      const responseUserList = [];
      for (const user of res.userList) {
        responseUserList.push({ id: user.id, name: `${user.name} ${user.lastName}` });
      }
      this.itemsList = this.usersList.concat(responseUserList);
    });
  }
}
